// Bootstrap 5 JavaScript bundle
// This file imports Bootstrap 5's JavaScript components for use with legacy code
// that relied on bootstrap-sprockets from the bootstrap-sass gem.

import * as bootstrap from 'bootstrap';

// Make bootstrap available globally for legacy code that expects it
window.bootstrap = bootstrap;

// Auto-initialize Bootstrap components on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize all tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach((tooltipTriggerEl) => {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Initialize all popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  popoverTriggerList.forEach((popoverTriggerEl) => {
    new bootstrap.Popover(popoverTriggerEl);
  });

  // Initialize all dropdowns (needed for dropdowns in table cells and other non-standard containers)
  const dropdownTriggerList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  dropdownTriggerList.forEach((dropdownTriggerEl) => {
    new bootstrap.Dropdown(dropdownTriggerEl);
  });
});

export default bootstrap;
